import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import Grid from '@material-ui/core/Grid';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';

import ContextoService from '../../services/Contexto';
import EnumService from '../../services/Enum';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Table from '../../components/Table/Table';
import Toast from '../../components/Toast/Toast';
import { 
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '../../components/Table/Utils';

import ContextoFilter from '../../forms/Contexto/ContextoFilter';

import { patternEnum } from '../../variables/Enums/Enum';

import AuthorizedFunction from '../../security/AuthorizedFunction';
import { __ADMINISTRADOR, __CENTRAL } from '../../security/RoleConfiguration';

import { Layout } from '../../layouts/private/Private';

import { verifyPersistence, removePagingAndSorting } from '../../helper/PaginationHelper';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: PAGE,
      size: SIZE,
      totalElements: TOTAL_ELEMENTS,
      totalPages: TOTAL_PAGES,
      sort: [{ orderBy: 'codigo', order: ASC }],
      defaultOrderBy: 'codigo',
      contexts: [],
      filtered: false,
      filters: [],
      loading: true,
      optionsType: [],
      optionsGrupoExibicao: [],
    }

    this.state = verifyPersistence(this.state, this.props.location);
  }  

  // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
  setToast = t => this.Toast = t;
  setContextoFilter = f => this.ContextoFilter = f;

  // LABELS
  labelEditar = id => !this.disabledEditar(id) ? "Editar" : "Você não tem permissão para fazer isso";

  // DISABLES
  disabledEditar = id => !AuthorizedFunction([__ADMINISTRADOR, __CENTRAL]);
  
  // EDIÇÃO
  handleEditClick = id => { 
    this.props.history.push({ 
      pathname: `/admin/contexto/${id}/editar`,
      state: {
        history: {
          path: `/admin/contexto/listagem`,
          state: this.state,
        }
      }
    })
  };

  // CARREGAR DADOS
  loadData = () => {
    let filters = verifyPagingAndSorting(this.state);

    this.setState({ 
      filters: [...filters], 
      filtered: true, 
      loading: true, 
    });

    ContextoService.filters(filters)
      .then(res => {
        if (res.data.content) {
          this.setState({ 
            contexts: [...res.data.content],
            page: res.data.number,
            size: res.data.size,
            totalElements: res.data.totalElements, 
            totalPages: res.data.totalPages,
            loading: false,
          });
        } else {
          this.setState({ 
            contexts: [],
            page: PAGE,
            size: SIZE,
            totalElements: TOTAL_ELEMENTS,
            totalPages: TOTAL_PAGES,
            loading: false,
          });
        }
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })

        this.setState({ loading: false });
      })   
  }
  
  // FILTROS
  filterData = (filters, isActive = true) => this.setState({ filtered: isActive, filters: [...removePagingAndSorting(filters)] }, () => this.loadData());

  // PÁGINA
  handlePage = page => this.setState({ page: page }, () => this.filterData(this.state.filters));

  // LINHAS POR PÁGINA
  handleRowsPerPage = (size, page) => this.setState({ size: size, page: page }, () => this.filterData(this.state.filters));

  // ORDENAÇÃO
  handleSort = (orderBy, order) => {
    if (this.state.sort.find(s => s.orderBy === orderBy)) {
        let newSort = this.state.sort.filter(s => s.orderBy !== orderBy);
        newSort.splice(this.state.sort.indexOf(this.state.sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
        this.setState({...this.state, sort: [...newSort], filtered: true });
    } else {
        this.setState({ ...this.state, sort: [...this.state.sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }], filtered: true });
    }
  }
  handleClearSort = (orderBy) => {
      this.setState({ ...this.state, filtered: true, sort: orderBy ? [...this.state.sort.filter(s => s.orderBy !== orderBy)] : [{ orderBy: this.state.defaultOrderBy, order: ASC }] });
  };

  // TOTAL DE PAGINAS
  handleTotalPages = () => this.state.totalPages;

  // TOTAL DE ELEMENTOS
  handleTotalElements = () => this.state.totalElements;

  // VERIFICAR PERSISTENCIA NO FORMULARIO DE FILTROS
  handleFilterPersistence = () => this.ContextoFilter ? this.ContextoFilter.state ? this.ContextoFilter.handleFilterPersistence(this.state.filters) : null : null;

  // COMPONENT DID MOUNT
  async componentDidMount() {       
    const tipos = await EnumService.listarTiposVariavel().then(res => res.data);
    const grupos = await EnumService.listarAgrupamentos().then(res => res.data);
    
    this.setState({ 
        optionsType: [...tipos], 
        optionsGrupoExibicao: [...grupos],
    });

    this.loadData(); 
  }

  render () {
    const pageName = 'Listagem de Variáveis';
    const links = [
      {
        path: null,
        name: 'Configurações'
      },
      { 
        path: '/admin/contexto', 
        name: 'Contexto' 
      }
    ];
  
    const columns = [
      { label: '#', name: 'id', func: null, key: true, hidden: true, },
      { label: 'Código', name: 'codigo', func: null, key: false },
      { label: 'Nome da Variável', name: 'variavel', func: null, key: false },
      { label: 'Tipo', name: 'tipo', func: (value, id) => patternEnum(value, this.state.optionsType), key: false },
      { label: 'Grupo de Exibição', name: 'agrupamento', func: (value, id) => patternEnum(value, this.state.optionsGrupoExibicao), key: false },
    ];
    
    const actions = [
      { 
        name: this.labelEditar,
        func: this.handleEditClick,
        icon: <EditOutlinedIcon />,
        disabled: this.disabledEditar,
      },
    ];

    this.handleFilterPersistence();

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={pageName} />
          </Grid>
        </Grid>
        <Title>{pageName}</Title>

        <Grid container >
          <Grid item xs={12}>
            <ContextoFilter 
              parentRef={this.setContextoFilter}
              handleFilterChange={this.filterData}
            />

            <Table
              loading={this.state.loading}         
              columns={columns}
              tableData={this.state.contexts}
              actions={actions}
              page={this.state.page}
              handlePage={this.handlePage}
              handleTotalPages={this.handleTotalPages}
              handleTotalElements={this.handleTotalElements}
              rowsPerPage={this.state.size}
              handleRowsPerPage={this.handleRowsPerPage}
              sort={this.state.sort}
              handleSort={this.handleSort}
              handleClearSort={this.handleClearSort}
            />
          </Grid>
        </Grid>
      </Layout>
    )
  }
}

export default withRouter(List);